import React from 'react'
import { getImageUrl } from '../utils/image'
import s from './CornerShops.less'

export default function CornerShops({ cornerShops }) {
  if (!cornerShops) return null
  return (
    <div className={s.text}>
      Présent ici :
      {cornerShops.map(({ id, iconUrl }) => (
        <img key={id} className={s.logo} src={getImageUrl(iconUrl)} />
      ))}
    </div>
  )
}
